/*global MatchRendering */
const Socket = function() {
    if (Generic.getParam('_update_method') == 'polling') {
        return {
            init: () => {}
        };
    }

    const lastScorePushes = [];
    const lastStatusPushes = [];
    let sendStats = Generic.getParam('sio_debug') == 1
        || Math.random() < 0.001 && typeof module === 'undefined';  // 0.1%, + avoid randomness in tests

    function matchRowSel(matchId) {
        return `table.ii__livescores tr[data-mid="${matchId}"]`;
    }

    const stateMap = {
        1: ['clr-blue fal fa-clock', 'Προγραμματισμένος'],
        2: ['clr-blue fal fa-play-circle', 'Παίζεται'],
        3: ['fas fa-adjust', 'Ημίχρονο'],
        4: ['clr-green fal fa-check-circle', 'Τελείωσε'],
        5: ['clr-red fal fa-stop-circle', 'Διακοπή'],
        6: ['clr-red fal fa-times-circle', 'Αναβολή'],
        7: ['fas fa-futbol', 'Παράταση / Πέναλτυ'],
        8: ['fal fa-eye-slash', 'Κρυμμένος']
    };

    // replicates php's MatchTableRendering::statusStr()
    function getStatusCell(stateId, currentMinute, scorePenalties, injuryTimeElapsed) {
        if ([2, 7].indexOf(stateId) >= 0 && currentMinute >= 1 && currentMinute <= 120) {
            let value = currentMinute;
            if (injuryTimeElapsed && [45, 90, 105, 120].indexOf(currentMinute) >= 0) {
                value += '+' + injuryTimeElapsed;
            }
            let htmlOut = `<span>${value}'</span>`;
            return {html: htmlOut, value: value, type: 'minute'};
        }
        if (stateId == 7 && !currentMinute) {  // in penalties
            if (!scorePenalties || scorePenalties == '0 - 0') {
                return;
            }
            let html = `<span class="penalties_container">Πεν<span class="penalty">${scorePenalties}</span></span>`;
            return {
                html: html,
                value: `Πεν ${scorePenalties}`,
                type: 'penalties'
            };
        }
        return {
            html:`<i class="${stateMap[stateId][0]}" title="${stateMap[stateId][1]}"></i>`,
            value: stateMap[stateId][1],
            type: 'state'
        };
    }

    function applyScoreUpdate(msg) {
        if (!msg.score_current) {
            return false;
        }
        if (Generic.mobile) {
            applySoccerMatchScoreUpdate(msg);
        }

        let selector = matchRowSel(msg.match_id) + ' td.ii__current_score_cell';
        if (!Generic.mobile) {
            selector += ' a';
        }
        let scoreCurrentEl = $(selector);
        if (scoreCurrentEl.length == 0) {
            return false;
        }
        let oldCont;
        let newCont = msg.score_current;
        if (Generic.mobile) {
            let oldScoreHome;
            let oldScoreAway;
            let pointerVisible;
            let newScoreParsed = msg.score_current.split(' - ');
            scoreCurrentEl.find('p').each(function(ix) {
                let scoreElem = $(this);
                if (ix == 0) {
                    oldScoreHome = scoreElem.html();
                    pointerVisible = oldScoreHome[oldScoreHome.length - 1] == '*';
                    if (pointerVisible) {
                        oldScoreHome = oldScoreHome[0];
                        newCont += '*';
                        newScoreParsed[0] += '*';
                    }
                    scoreElem.html(newScoreParsed[0]);
                } else {
                    oldScoreAway = scoreElem.html();
                    scoreElem.html(newScoreParsed[1]);
                }
            });
            oldCont = `${oldScoreHome} - ${oldScoreAway}${(pointerVisible ? '*' : '')}`;
        } else {
            oldCont = scoreCurrentEl.html();
            if (oldCont && oldCont[oldCont.length - 1] == '*') {
                newCont += '*';
            }
            scoreCurrentEl.html(newCont);
        }

        if (msg.last_score_change_diff > 0 && Date.now() / 1000 < msg.last_score_change + 180) {  // show 'ΓΚΟΛ' for up to 3 mins.
            $(matchRowSel(msg.match_id)).attr('data-recent-goal', msg.last_score_change);
        }
        return {fromValue: oldCont, toValue: msg.score_current};
    }

    function applySoccerMatchScoreUpdate(msg) {
        if (!msg.score_current) {
            return;
        }
        const soccerMatchId = $('.ii__soccer_match_container').data('mid');
        if (!soccerMatchId || soccerMatchId != msg.match_id) {
            return;  // no overlay or push concerns other match
        }
        MatchRendering.updateScore(msg.score_current, msg.state_id);
    }

    function applyStatusUpdate(msg) {
        if (Generic.mobile) {
            applySoccerMatchStatusUpdate(msg);
        }

        const selector = matchRowSel(msg.match_id) + ' .ii__goal_indicator';
        const statusEl = $(selector);
        if (statusEl.length == 0) {
            return false;
        }
        const matchRow = $(matchRowSel(msg.match_id));
        if (msg.state_id && !matchRow.hasClass('ii__match_state_' + msg.state_id)) {
            matchRow[0].className = matchRow[0].className.replace(
                /ii__match_state_[1-8]/, 'ii__match_state_' + msg.state_id
            );
        }
        const statusCell = getStatusCell(
            msg.state_id, msg.current_minute, msg.score_penalties, msg.injury_time_elapsed
        );
        if (!statusCell) {
            return false;
        }
        let oldCont = statusEl.find('i');
        if (oldCont.length > 0) {
            oldCont = oldCont.attr('title');  // from state to minute
        } else {
            oldCont = statusEl.text().trim().replace("'", '');
        }
        if (statusEl.find('span.goal').length == 1 && statusCell.type == 'minute') {
            statusCell.html += '<span class="goal">ΓΚΟΛ</span>';
        }
        statusEl.html(statusCell.html);
        return {fromValue: oldCont, toValue: statusCell.value};
    }

    function applySoccerMatchStatusUpdate(msg) {
        if (msg.state_id == 7 && !msg.current_minute) {
            return; // nothing we can do about penalties yet
        }
        const soccerMatchId = $('.ii__soccer_match_container').data('mid');
        if (!soccerMatchId || soccerMatchId != msg.match_id) {
            return;  // no overlay or push concerns other match
        }
        MatchRendering.updateStatus(msg.state_id, msg.current_minute, msg.injury_time_elapsed);
    }

    function uploadStats(msg, updateEventType, appliedUpdate) {
        if (!sendStats) {
            return;
        }
        const statsPayload = [{
            event_type: 'message_received',
            match_id: msg.match_id,
        }];
        if (appliedUpdate) {
            statsPayload.push({
                event_type: updateEventType,
                match_id: msg.match_id,
                from_value: appliedUpdate.fromValue,
                to_value: appliedUpdate.toValue
            });
        }
        Ajax.sendSocketClientStats(JSON.stringify(statsPayload));
    }

    function enableSendStats() {
        sendStats = true;
    }

    function processPastPush(msg, pushType) {
        const $matchRow = $(matchRowSel(msg.match_id));
        if ($matchRow.length == 0) {
            return;
        }
        let polledLastChange = $matchRow.data(`last-${pushType}-change`);
        if (!polledLastChange || msg[`last_${pushType}_change`] > polledLastChange) {
            if (pushType == 'score') {
                applyScoreUpdate(msg);
            } else if (pushType == 'status') {
                applyStatusUpdate(msg);
            }
        }
    }

    if (typeof exports !== 'undefined') {
        exports.enableSendStats = enableSendStats;
        exports.lastScorePushes = lastScorePushes;
        exports.lastStatusPushes = lastStatusPushes;
    }

    return {
        init: () => {
            const socket = io({
                reconnection: true,
                reconnectionDelay: 1000,
                reconnectionDelayMax : 3000,
                reconnectionAttempts: Infinity
            });

            socket.on('updates.score', function(data) {
                const msg = JSON.parse(data);
                lastScorePushes.push(msg);  // match_id, score_current, last_score_change
                const res = applyScoreUpdate(msg);
                if (res) {
                    MatchesTable.goalIndicator(msg.match_id);
                }
                uploadStats(msg, 'score_updated', res);
            });

            socket.on('updates.status', function(data) {
                const msg = JSON.parse(data);
                lastStatusPushes.push(msg);
                const res = applyStatusUpdate(msg);
                uploadStats(msg, 'status_updated', res);
            });
        },
        reapplySocketUpdates: function() {
            for (const msg of lastScorePushes) {
                processPastPush(msg, 'score');
            }
            for (const msg of lastStatusPushes) {
                processPastPush(msg, 'status');
            }
        }
    };
}();

if (typeof exports !== 'undefined') {
    exports.init = Socket.init,
    exports.reapplySocketUpdates = Socket.reapplySocketUpdates;
}
